module.exports = __webpack_public_path__ + "img/kv_1_1.4bc4ef8d.png";